<template>
  <base-layout :headline="headline">
    <template #header>
      <WorkspaceAnnouncementBar v-if="isAuthenticated" />
      <authenticated-navbar></authenticated-navbar>
    </template>
    <div>
      <!-- Loading spinner
      <spinner size="large"></spinner>
      -->
    </div>
    <div class="flex w-full min-h-screen bg-gray-100 overflow-x-hidden">
      <!-- Child components -->
      <Sidebar
        class="xl:w-[13%] lg:w-[16%] md:w-[20%] sm:w-[22%] w-0"
      ></Sidebar>
      <div
        class="xl:w-[87%] lg:w-[84%] md:w-[80%] sm:w-[87%] w-full h-auto lg:p-12 p-4"
      >
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
    <AiAssistantButton v-if="isAuthenticated" />
    <AiAssistantSidebar v-if="isAuthenticated" />
  </base-layout>
</template>

<script>
import AuthenticatedNavbar from "../components/Navigation/AuthenticatedNavbar.vue";
import BaseLayout from "./BaseLayout.vue";
import Spinner from "../components/Widgets/Spinner/LoadingSpinner.vue";
import Sidebar from "../components/Navigation//Sidebar/SidebarMenu.vue";
import AiAssistantButton from "@/modules/aiAssistant/AiAssistantButton.vue";
import AiAssistantSidebar from "@/modules/aiAssistant/AiAssistantSidebar.vue";
import WorkspaceAnnouncementBar from "@/components/Widgets/WorkspaceAnnouncementBar.vue";

export default {
  data() {
    return {
      loading: true,
    };
  },
  props: ["headline"],
  components: {
    BaseLayout,
    AuthenticatedNavbar,
    Spinner,
    Sidebar,
    AiAssistantButton,
    AiAssistantSidebar,
    WorkspaceAnnouncementBar,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  async created() {
    if (this.$store.getters.isAuthenticated && this.$store.state.user) {
      const permissions = this.$store.state.user.permissions;
      if (!permissions || permissions.length === 0) {
        try {
          await this.$store.dispatch(
            "setUserAndPermissions",
            this.$store.state.user
          );
          this.$root.$emit("PermissionsChanged");
        } catch (e) {
          // Permission refresh failure is non-blocking for layout creation.
        }
      }
      // Ask the chat backend whether this officer is on the AI allowlist. The
      // bubble stays hidden until this resolves (state defaults to allowed=null).
      this.$store.dispatch("aiAssistant/fetchAccess");
    }
  },
};
</script>

<style></style>
